import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  PieChart,
  Pie,
  Cell,
  Line,
  ComposedChart,
  LineChart,
} from "recharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./WelcomeScreen.css"; // Import custom CSS for styling
import axios from "axios";
import * as XLSX from "xlsx";
import { FaEye } from "react-icons/fa";
import { IoMdCloudDownload } from "react-icons/io";
import { FaDownload } from "react-icons/fa6";
// import styled from 'styled-components';
import { toast, ToastContainer } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import styles
import { getBestdealsClicks, getStoreClicks, getallPincode, Deletewidget } from "../apiconfig/authService";
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const WelcomeScreen = () => {
  const [productClickData, setProductClickData] = useState([]);
  const [storeClickData, setStoreClickData] = useState([]);
  const [betsdealClickData, setBetsdealClickData] = useState([]);
  const [productClickStartDate, setProductClickStartDate] = useState(
    new Date()
  );
  const [storeClickStartDate, setStoreClickStartDate] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  });
  const [bestdealClickStartDate, setBestdealClickStartDate] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  });
  const [productClickEndDate, setProductClickEndDate] = useState(new Date());
  const [storeClickEndDate, setStoreClickEndDate] = useState(new Date());
  const [bestdealClickEndDate, setBestdealClickEndDate] = useState(new Date());

  const [cartData, setCartData] = useState([]);
  const [cartStartDate, setCartStartDate] = useState(new Date());
  const [cartEndDate, setCartEndDate] = useState(new Date());

  const [totalCartsPerDay, setTotalCartsPerDay] = useState(0);

  const [popularProductData, setPopularProductData] = useState([]);
  const [popularProductStartDate, setPopularProductStartDate] = useState(
    new Date()
  );
  const [popularProductEndDate, setPopularProductEndDate] = useState(
    new Date()
  );

  const [searchInfoData, setSearchInfoData] = useState([]);
  const [searchInfoStartDate, setSearchInfoStartDate] = useState(new Date());
  const [searchInfoEndDate, setSearchInfoEndDate] = useState(new Date());

  // const [categoryData, setCategoryData] = useState([]);
  const [categoryStartDate, setCategoryStartDate] = useState(new Date());
  const [subcategoryStartDate, setSubcategoryStartDate] = useState(new Date());
  const [categoryEndDate, setCategoryEndDate] = useState(new Date());
  const [subcategoryEndDate, setSubcategoryEndDate] = useState(new Date());

  const [viewType, setViewType] = useState("Category");
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [subcategoryData, setSubcategoryData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [phoneNumber, setPhoneNumber] = useState("");
  const [pincode, setPincode] = useState("");
  const [pincodeList, setPincodeList] = useState([]);
  // console.log("pincodeList?????", pincodeList)
  const [pincodes, setPincodes] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [details, setDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const fetchProductClickData = async () => {
      try {
        const queryParams = {
          startDate: startDate ? startDate.toISOString().split('T')[0] : null,
          endDate: endDate ? endDate.toISOString().split('T')[0] : null,
        };

        const response = await fetch(
          `https://backend.pikeazy.in/product/getproductclick?startDate=${productClickStartDate.toISOString()}&endDate=${productClickEndDate.toISOString()}`
        );
        // const response = await GetProductclickdata(
        //   queryParams,
        //   localStorage.getItem("accessToken")
        // );
        const result = await response.json();

        if (response.ok) {
          const rawData = result?.getproductClick;

          const transformedData = rawData.map((item) => ({
            productid: item?._id,
            productname: item?.productDetails?.name || "Unknown",
            totalClicks: item?.totalClicks,
          }));

          setProductClickData(transformedData);
        } else {
          console.error("Error fetching data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProductClickData();
  }, [productClickStartDate, productClickEndDate]);

  useEffect(() => {
    const fetchProductClickData = async () => {
      try {
        const queryParams = {
          startDate: storeClickStartDate ? storeClickStartDate.toISOString() : null,
          endDate: storeClickEndDate ? storeClickEndDate.toISOString() : null,
          phonenumber: phoneNumber || '',
          pincode: pincode || ''
        };

        const response = await getStoreClicks(queryParams, localStorage.getItem("accessToken"));

        console.log("result>>>>>>>>>>>>", response.data);

        const rawData = response?.data?.getsearchproduct;

        const transformedData = rawData.map((item) => ({
          phonenumber: item?.phonenumber,
          storename: item?.storename || "Unknown",
          totalClicks: item?.totalClicks,
        }));

        setStoreClickData(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }

    };

    fetchProductClickData();
  }, [storeClickStartDate, storeClickEndDate, phoneNumber, pincode]);

  useEffect(() => {
    const fetchbestdealClickData = async () => {
      try {
        const queryParams = {
          startDate: bestdealClickStartDate ? bestdealClickStartDate.toISOString() : null,
          endDate: bestdealClickEndDate ? bestdealClickEndDate.toISOString() : null,
          phonenumber: phoneNumber || '',
          pincode: pincode || ''
        };

        const response = await getBestdealsClicks(queryParams, localStorage.getItem("accessToken"));

        const rawData = response?.data?.getsearchproduct;
        console.log("rawData", rawData)
        const transformedData = rawData.map((item) => ({
          phonenumber: item?.phonenumber,
          pagename: item?.pageName || "Unknown",
          totalClicks: item?.totalClicks,
        }));

        setBetsdealClickData(transformedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchbestdealClickData();
  }, [bestdealClickStartDate, bestdealClickEndDate, pincode, phoneNumber]);

  useEffect(() => {
    const fetchPincode = async () => {
      try {
        const response = await getallPincode(pincode, localStorage.getItem("accessToken"))
        const data = response?.data?.pincodes
        console.log("data??????????", data)
        const activePincodes = data.filter(item => item.isactive === 1);
        setPincodeList(activePincodes)
        console.log("activePincodes??????", activePincodes)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchPincode()
  }, [])

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        const response = await fetch(
          `https://backend.pikeazy.in/cart/cartbydate?startDate=${cartStartDate.toISOString()}&endDate=${cartEndDate.toISOString()}`
        );
        const result = await response.json();

        if (response.ok) {
          const totalCarts = result.reduce(
            (sum, dateEntry) => sum + dateEntry.totalCartsPerDay,
            0
          );
          setTotalCartsPerDay(totalCarts);

          const flattenedData = result.flatMap((dateEntry) =>
            dateEntry.cart.flatMap((cartEntry) =>
              cartEntry.productsInfo.map((productInfo) => ({
                name: `${cartEntry.phonenumber} - ${productInfo.productname}`,
                value: 1, // Each entry represents one cart, adjust if needed
                date: dateEntry.date,
              }))
            )
          );

          setCartData(flattenedData);
        } else {
          console.error("Error fetching data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCartData();
  }, [cartStartDate, cartEndDate]);

  useEffect(() => {
    const fetchPopularProductData = async () => {
      try {
        const response = await fetch(
          `https://backend.pikeazy.in/product/getpopularproduct?startDate=${popularProductStartDate.toISOString()}&endDate=${popularProductEndDate.toISOString()}`
        );
        const result = await response.json();
        const dataArray = Array.isArray(result)
          ? result.getpopularProduct
          : result.getpopularProduct;

        if (response.ok) {
          const transformedData = dataArray.map((item) => ({
            productid: item?._id,
            productname: item?.productDetails?.name || "Unknown",
            totalClicks: item?.totalClicks,
          }));

          setPopularProductData(transformedData);
        } else {
          console.error("Error fetching popular product data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching popular product data:", error);
      }
    };

    fetchPopularProductData();
  }, [popularProductStartDate, popularProductEndDate]);

  useEffect(() => {
    const fetchSearchInfoData = async () => {
      try {
        const response = await fetch(
          `https://backend.pikeazy.in/product/getsearchinfo?startDate=${searchInfoStartDate.toISOString()}&endDate=${searchInfoEndDate.toISOString()}`
        );
        const result = await response.json();
        const dataArray = Array.isArray(result)
          ? result.getsearchproduct
          : result.getsearchproduct;

        if (response.ok) {
          const transformedData = dataArray.map((item) => ({
            productid: item?.productid,
            pageName: item?.pageName,
            totalClicks: item?.totalClicks,
            productname: item?.productName || "Unknown",
          }));
          console.log("transformedData>>>>>>", transformedData);
          setSearchInfoData(transformedData);
        } else {
          console.error("Error fetching search info data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching search info data:", error);
      }
    };

    fetchSearchInfoData();
  }, [searchInfoStartDate, searchInfoEndDate]);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const response = await fetch(
          `https://backend.pikeazy.in/product/getcategoryinfo?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
        );
        const result = await response?.json();
        console.log("result", result);
        if (response.ok) {
          setCategoryData(result?.data);
        } else {
          console.error("Error fetching category data:", result?.message);
        }
      } catch (error) {
        console.error("Error fetching category data:", error);
      }
    };

    fetchCategoryData();
  }, [endDate, startDate]);

  useEffect(() => {
    const fetchsubCategoryData = async () => {
      try {
        const response = await fetch(
          `https://backend.pikeazy.in/product/getsubcategoryInfo?startDate=${startDate.toISOString()}&endDate=${startDate.toISOString()}`
        );
        const result = await response.json();
        console.log("result", result);
        if (response.ok) {
          setSubcategoryData(result?.data);
        } else {
          console.error("Error fetching category data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching category data:", error);
      }
    };

    fetchsubCategoryData();
  }, [startDate, startDate]);

  const totalProductClicks = productClickData.reduce(
    (sum, item) => sum + item.totalClicks,
    0
  );
  const totalbestdealClicks = betsdealClickData.reduce(
    (sum, item) => sum + item.totalClicks,
    0
  );

  const totalStoreClicks = storeClickData.reduce(
    (sum, item) => sum + item.totalClicks,
    0
  );

  const totalPopularProductClicks = popularProductData.length;
  const totalsearchproduct = searchInfoData.length;
  const totalcategoryData = categoryData.length;
  const totalsubcategoryData = subcategoryData.length;

  const CustomTooltip = ({ payload }) => {
    console.log("payload>>>>>", payload);
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`Phonenumber: ${payload[0].payload.productname}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  const CustomTooltipstore = ({ payload }) => {
    console.log("payload>>>>>", payload);
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`storename: ${payload[0].payload.storename}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  const CustomTooltipbestdeal = ({ payload }) => {
    console.log("payloa??", payload);
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`pageName: ${payload[0].payload.pagename}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  const PopularProductCustomTooltip = ({ payload }) => {
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`Product: ${payload[0].payload.productname}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  const CategoryCustomTooltip = ({ payload }) => {
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`Category: ${payload[0].payload.categoryName}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  const SubcategoryCustomTooltip = ({ payload }) => {
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`Subcategory: ${payload[0].payload.subcategoryName}`}</p>
          <p>{`Total Clicks: ${payload[0].payload.totalClicks}`}</p>
        </div>
      );
    }
    return null;
  };

  useEffect(() => {
    const fetchSubcategoryData = async () => {
      if (selectedSubcategory && viewType === "Subcategory") {
        try {
          const response = await fetch(
            `http://localhost:4000/product/getsubcategorydata?subcategoryid=${selectedSubcategory}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
          );
          const result = await response.json();
          // setSubcategoryData(result); // Adjust as per the structure of your response
        } catch (error) {
          console.error("Error fetching subcategory data:", error);
        }
      }
    };

    fetchSubcategoryData();
  }, [selectedSubcategory, startDate, endDate, viewType]);

  const handleViewTypeChange = (event) => {
    setViewType(event.target.value);
    setSelectedSubcategory(""); // Clear subcategory when view type changes
  };

  // const handleCategoryChange = (event) => {
  //   setSelectedCategory(event.target.value);
  // };

  // const handleSubcategoryChange = (event) => {
  //   setSelectedSubcategory(event.target.value);
  // };

  const chartData = viewType === "Subcategory" ? subcategoryData : categoryData;
  const totalData =
    viewType === "Subcategory"
      ? `Subcategory ${totalsubcategoryData}`
      : `Category ${totalcategoryData}`;

  const fetchCartDetails = async () => {
    try {
      const requestData = {
        phoneNumber,
        pincode,
        startDate,
        endDate,
      };

      const response = await axios.post(
        "https://scrapbackend.pikeazy.in/customer/getUserData",
        requestData
      );

      if (response.data.status === "success") {
        const cartData = response?.data?.data?.cart?.products;
        const Name = response?.data?.data?.name;
        const Email = response?.data?.data?.email;

        const combinedData = cartData.map((product) => {
          const priceFor122002 =
            product.PriceDifference.find(
              (priceDiff) => priceDiff.pincode === "122002"
            )?.price || "N/A";
          const priceFor122001 =
            product.PriceDifference.find(
              (priceDiff) => priceDiff.pincode === "122001"
            )?.price || "N/A";

          return {
            customerName: product?.customerName,
            customerEmail: product?.customerEmail,
            ProductSelected: product?.ProductSelected,
            Quantity: product?.Quantity,
            Timestamp: new Date(product?.Timestamp).toLocaleDateString("en-GB"),
            customerId: product?.customerId,
            Brand: "",
            Location: product?.location,
            cartValue: product?.totalPrice,
            PriceDifference122002: priceFor122002,
            PriceDifference122001: priceFor122001,
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(combinedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Cart Details");
        XLSX.writeFile(workbook, "CartDetails.xlsx");
      } else {
        setErrorMessage(response.data.message || "Error fetching data");
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "API error occurred");
    }
  };

  const fetchStorDetails = async () => {
    try {
      const queryParams = new URLSearchParams({
        startDate: new Date(storeClickStartDate).toISOString(),
        endDate: new Date(storeClickEndDate).toISOString(),
        phonumber: phoneNumber || "",
        pincode: pincode || "",
      });

      // const response = await axios.get(`https://scrapbackend.pikeazy.in/product/getStoreClicks?${queryParams.toString()}`);
      const response = await getStoreClicks(queryParams, localStorage.getItem("accessToken"));

      if (response?.data?.status === 200) {
        const clickData = response?.data?.getsearchproduct;

        if (!clickData.length) {
          toast.error("No data available for the selected filters.");
          return;
        }

        // Optional: clean or rename fields if needed
        const formattedData = clickData.map((item) => ({
          StoreName: item?.storename,
          Pincode: item?.pincode,
          PhoneNumber: item?.phonenumber,
          ClickDate: item?.date,
          TotalClicks: item?.totalClicks,
          Name: item?.name || item?.name || "",  // Fallback
          Email: item?.email || item?.email || "",
        }));
        console.log("formattedData", formattedData)
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Store Clicks");

        XLSX.writeFile(workbook, "StoreClickDetails.xlsx");
      } else {
        setErrorMessage(response?.data?.message || "Failed to fetch store clicks.");
      }
    } catch (error) {
      console.error("Error fetching store clicks:", error);
      setErrorMessage(error.response?.data?.message || "API request failed.");
    }
  };

  const fetchbestdealDetails = async () => {
    try {
      const queryParams = new URLSearchParams({
        startDate: new Date(storeClickStartDate).toISOString(),
        endDate: new Date(storeClickEndDate).toISOString(),
        phonumber: phoneNumber || "",
        pincode: pincode || "",
      });

      // const response = await axios.get(`https://scrapbackend.pikeazy.in/product/getbestdealclick?${queryParams.toString()}`);
      const response = await getBestdealsClicks(queryParams, localStorage.getItem("accessToken"));
      console.log("BESTDEAL", response)
      if (response.data.status === 200) {
        const clickData = response?.data?.getsearchproduct;

        if (!clickData.length) {

          toast.error("No data available for the selected filters.");
          return;
        }

        // Optional: clean or rename fields if needed
        const formattedData = clickData.map((item) => ({
          PageName: item?.pageName,
          Pincode: item?.pincode,
          PhoneNumber: item?.phonenumber,
          ClickDate: item?.date,
          TotalClicks: item?.totalClicks,
          Name: item?.name || item?.name || "",  // Fallback
          Email: item?.email || item?.email || "",
        }));
        console.log("formattedData", formattedData)
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Store Clicks");

        XLSX.writeFile(workbook, "BestDealDetails.xlsx");
      } else {
        setErrorMessage(response?.data?.message || "Failed to fetch store clicks.");
      }
    } catch (error) {
      console.error("Error fetching store clicks:", error);
      setErrorMessage(error?.response?.data?.message || "API request failed.");
    }
  };

  const fetchDetails = async () => {
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const requestData = {
        phoneNumber,
        pincode,
        startDate, // Include startDate
        endDate, // Include endDate
      };

      const response = await axios.post(
        "https://scrapbackend.pikeazy.in/customer/getUserData",
        requestData
      );
      if (response.data.status === "success") {
        const cartProducts = response.data.data.cart.products;
        if (!cartProducts || cartProducts.length === 0) {
          setErrorMessage("No cart found for this user");
          toast.error("No cart found for this user");
          return;
        }
        const formattedProducts = cartProducts.map((product) => ({
          ...product,
          Timestamp: new Date(product.Timestamp).toLocaleDateString("en-GB"), // Formats to dd/mm/yyyy
        }));
        setDetails(formattedProducts);
        setUserName(response.data.data.name);
        setUserEmail(response.data.data.email);
      } else {
        toast.error("User not found");
      }
    } catch (err) {
      setErrorMessage("API error occurred.");
      toast.error("User not found");
    } finally {
      setIsLoading(false);
    }
  };

  // console.log("details???????", details);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="main">
        <div className="heading-excel-form">
          <div className="welcome-heading">
            <div className="left-welcome">
              <img src="/static/media/logo.1c08c1e01e0bf9677c66.png" alt="" className="logo-welcome" />
            </div>
            <div className="right-welcome">
              {/* <span className="firstwelcome">Welcome</span> 
              <span className="secondwelcome">To</span>
              <span className="thirdwelcome">Pikeazy</span> */}
              <span className="firstwelcome">Welcome To <span className="thirdwelcome">Pikeazy</span></span>
            </div>
          </div>

          {/* 
          <div className="container-fluid downloadexcel-form">
            <h2 className="form-title">Download and View Details</h2>
            <div className="container_Inputs">
              <div className="form-group">
                <input
                  type="date"
                  className="form-input"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="Start Date"
                />
              </div>

              <div className="form-group">
                <input
                  type="date"
                  className="form-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  placeholder="End Date"
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Phone Number"
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                  placeholder="Pincode"
                />
              </div>
            </div>
            <div className="container_flex my-3">
              <div className="button-group">
                <button className="form-button" onClick={fetchCartDetails}>
                  <FaDownload className="button-icon" /> Download Excel
                </button>
                <button className="form-button">
                  <FaEye className="button-icon" /> View Details
                </button>
              </div>
            </div>

            {isLoading && <p>Loading details...</p>}
            {details.length > 0 && (
              <div className="table-container">
                <table className="details-table">
                  <thead>
                    <tr>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: "150px",
                        }}
                      >
                        Name
                      </th>
                      <th>Email</th>
                      <th>CustomerId</th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: "150px",
                        }}
                      >
                        Product ID
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: "150px",
                        }}
                        scope="col"
                      >
                        Product Name
                      </th>
                      <th>Quantity</th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: "150px",
                        }}
                      >
                        Price 122002
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: "150px",
                        }}
                      >
                        Price 122001
                      </th>
                      <th>AddedDate</th>
                      <th>TotalPrice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.map((product, index) => {
                      const price122002 =
                        product.PriceDifference?.find(
                          (p) => p.pincode === "122002"
                        )?.price || "N/A";
                      const price122001 =
                        product.PriceDifference?.find(
                          (p) => p.pincode === "122001"
                        )?.price || "N/A";

                      return (
                        <tr key={index}>
                          <td>{product.customerName}</td>
                          <td>{product.customerEmail}</td>
                          <td>{product.customerId}</td>
                          <td>{product.productId || "N/A"}</td>{" "}
                          
                          <td>{product.ProductSelected}</td>
                          <td>{product.Quantity}</td>
                          <td>{price122002}</td>
                          <td>{price122001}</td>
                          <td>{product.Timestamp}</td>
                          <td>{product.totalPrice}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>' */}
        </div>

        {/* Product Click Data */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Store Click Data</h2>
                    <h5 className="totalproductclick">
                      Total Product Clicks: {totalStoreClicks}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={storeClickStartDate}
                              onChange={(date) => setStoreClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold w-1/4">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={storeClickEndDate}
                              onChange={(date) => {
                                if (storeClickStartDate && date < storeClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setStoreClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchStorDetails}

                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="chart-container h-100">
                    <BarChart
                      width={730}
                      height={500}
                      data={storeClickData}
                      margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="totalClicks" textAnchor="end" />
                      <YAxis />
                      <Tooltip content={<CustomTooltipstore />} />
                      <Legend formatter={(value) => <span>{value}</span>} />
                      <Bar
                        dataKey="totalClicks"
                        fill="#97c93c"
                        stroke="#fff"
                        strokeWidth={1}
                        barSize={30}
                        radius={[5, 5, 0, 0]}
                      >
                        <LabelList
                          dataKey="totalClicks"
                          position="top"
                          formatter={(value) => `${value}`}
                        />
                      </Bar>
                    </BarChart>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Best Deals Click Data</h2>
                    <h5 className="totalproductclick">
                      Total Product Clicks: {totalbestdealClicks}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickStartDate}
                              onChange={(date) => setBestdealClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickEndDate}
                              onChange={(date) => {
                                if (bestdealClickStartDate && date < bestdealClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setBestdealClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchbestdealDetails}

                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="chart-container h-100">
                    <BarChart
                      width={730}
                      height={500}
                      data={betsdealClickData}
                      margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="totalClicks" textAnchor="end" />
                      <YAxis />
                      <Tooltip content={<CustomTooltipbestdeal />} />
                      <Legend formatter={(value) => <span>{value}</span>} />
                      <Bar
                        dataKey="totalClicks"
                        fill="#97c93c"
                        stroke="#fff"
                        strokeWidth={1}
                        barSize={30}
                        radius={[5, 5, 0, 0]}
                      >
                        <LabelList
                          dataKey="totalClicks"
                          position="top"
                          formatter={(value) => `${value}`}
                        />
                      </Bar>
                    </BarChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Cart Data */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">

                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Cart Click Data</h2>
                    <h5 className="totalproductclick">
                      {/* Total Product Clicks: {totalbestdealClicks} */}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickStartDate}
                              onChange={(date) => setBestdealClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickEndDate}
                              onChange={(date) => {
                                if (bestdealClickStartDate && date < bestdealClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setBestdealClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchbestdealDetails}
                              disabled
                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="chart-container h-100">
                    <PieChart width={519} height={576}>
                      <Pie
                        data={cartData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={150}
                        fill="#8884d8"
                        label
                      >
                        {cartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>


                      <Tooltip
                        formatter={(value, name) => [value, name]}
                        labelFormatter={(label) => `Product: ${label}`}
                      />
                      <Legend formatter={(value) => <span>{value}</span>} />
                    </PieChart>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Popular Products */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Popular Product Click Data</h2>
                    <h5 className="totalproductclick">
                      {/* Total Product Clicks: {totalbestdealClicks} */}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickStartDate}
                              onChange={(date) => setBestdealClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickEndDate}
                              onChange={(date) => {
                                if (bestdealClickStartDate && date < bestdealClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setBestdealClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchbestdealDetails}
                              disabled
                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="chart-container h-100">
                    <ComposedChart width={519} height={460} data={popularProductData}>
                      <XAxis dataKey="productid" />
                      <YAxis />
                      <Tooltip content={<PopularProductCustomTooltip />} />
                      <Legend formatter={(value) => <span>{value}</span>} />
                      <CartesianGrid stroke="#f5f5f5" />
                      <LineChart
                        type="monotone"
                        dataKey="totalClicks"
                        fill="#8884d8"
                        stroke="#8884d8"
                      />
                      <Bar dataKey="totalClicks" barSize={2} fill="#97c93c" />
                      <Line type="monotone" dataKey="totalClicks" stroke="#198754" />
                    </ComposedChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search Info Data */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">
                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Search Click Data</h2>
                    <h5 className="totalproductclick">
                      {/* Total Product Clicks: {totalbestdealClicks} */}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickStartDate}
                              onChange={(date) => setBestdealClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickEndDate}
                              onChange={(date) => {
                                if (bestdealClickStartDate && date < bestdealClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setBestdealClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchbestdealDetails}
                              disabled
                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="chart-container h-100">
                    <BarChart
                      width={519}
                      height={460}
                      data={searchInfoData}
                      margin={{ top: 50, right: 30, left: 20, bottom: 20 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="productid" textAnchor="end" />
                      <YAxis />
                      <Tooltip content={<CustomTooltip />} />
                      <Legend formatter={(value) => <span>{value}</span>} />
                      <Bar
                        dataKey="totalClicks"
                        fill="#97c93c"
                        stroke="#fff"
                        strokeWidth={1}
                        barSize={30}
                        radius={[5, 5, 0, 0]}
                      >
                        <LabelList
                          dataKey="totalClicks"
                          position="top"
                          formatter={(value) => `${value}`}
                        />
                      </Bar>
                    </BarChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Category Data */}

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-6">

                  <div className="heading-date-input h-100">
                    <h2 className="section-heading">Category Click Data</h2>
                    <h5 className="totalproductclick">
                      {/* Total Product Clicks: {totalbestdealClicks} */}
                    </h5>
                    <table className="table-auto w-full border border-gray-300">
                      <tbody>
                        <tr>
                          <td className="p-2 font-semibold w-1/4">Start Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickStartDate}
                              onChange={(date) => setBestdealClickStartDate(date)}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">End Date:</td>
                          <td className="p-2">
                            <DatePicker
                              selected={bestdealClickEndDate}
                              onChange={(date) => {
                                if (bestdealClickStartDate && date < bestdealClickStartDate) {
                                  toast.error("End date cannot be earlier than start date.");
                                  return;
                                }
                                setBestdealClickEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Phone Number:</td>
                          <td className="p-2">
                            <input
                              type="text"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone Number"
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            />
                          </td>
                        </tr>

                        <tr>
                          <td className="p-2 font-semibold">Pincode:</td>
                          <td className="p-2">
                            <select
                              id="pincode-select"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              className="form-input w-full h-10 px-3 text-sm border border-gray-300 rounded"
                            >
                              {pincodeList.map((item) => (
                                <option key={item._id} value={item.pincode}>
                                  {item.pincode} - {item.city}
                                </option>
                              ))}
                            </select>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" className="p-2 text-center">
                            <button
                              className="form-button w-48 h-10 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                              onClick={fetchbestdealDetails}
                            >
                              <FaDownload className="inline mr-2" />
                              Download Excel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-lg-6">
                  {/* Chart Display */}
                  <div className="chart-container h-100">
                    {/* <BarChart
                        width={519}
                        height={300}
                        data={chartData}
                        margin={{ top: 50, right: 30, left: 20, bottom: 20 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="categoryid" textAnchor="end" />
                        <YAxis />
                        <Tooltip content={<CategoryCustomTooltip />} />
                        <Legend />
                        <Bar
                          dataKey="totalClicks"
                          fill="#97c93c"
                          stroke="#fff"
                          strokeWidth={1}
                          barSize={30}
                          radius={[5, 5, 0, 0]}
                        >
                          <LabelList dataKey="totalClicks" position="top" />
                        </Bar>
                      </BarChart> */}
                    <LineChart
                      width={600}
                      height={460}
                      data={chartData}
                      margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
                    >
                      <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                      <XAxis
                        dataKey={
                          viewType === "Subcategory" ? "subcategoryid" : "categoryid"
                        }
                      />
                      <YAxis />
                      <Tooltip
                        content={
                          viewType === "Subcategory" ? (
                            <SubcategoryCustomTooltip />
                          ) : (
                            <CategoryCustomTooltip />
                          )
                        }
                      />
                      <Line type="monotone" dataKey="totalClicks" stroke="#8884d8" />
                    </LineChart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <ToastContainer />
    </div>
  );
};

export default WelcomeScreen;
